import { useContext, useEffect, useRef, useState } from "react";
import { GlobalDataContext } from "../../../contexts/GlobalData";
import { MY_CLINIC, SPAS_HOME_PAGE } from "../../../enums/PrivilegeTags";
import { MASTER } from "../../../enums/Roles";
import {
  ABOUT_US,
  AI_ASSISTANT,
  APPOINTEMENTS,
  RESERVATION_ADMINISTRATION,
  TEMPLATE,
} from "../../../enums/UrlPaths";
import useUser from "../../../hooks/useUser";
import { NAV_BAR_PAGES, STACIONAR_MAIL_PAGES } from "../enums/NavBarPages";
import { STACIONAR_EMAIL } from "../../../features/home/HomePage";
//This method updates the navigation titles only if the permissions are changed
//This code is horendus...
function useGetCollapsedSidebarIcons() {
  const availablePages = [];
  const { currentClinic, roles, profile } = useUser();
  const { permissions, getPermissionTitlesArray } =
    useContext(GlobalDataContext);
  // State to store the filtered pages
  const [filteredPages, setFilteredPages] = useState([]);

  // useRef to store the old permission titles array
  const prevPermissionTitlesRef = useRef([]);

  useEffect(() => {
    const currentPermissionTitles = getPermissionTitlesArray(permissions);
    const userRole = profile.role;
    // Check if there is a new value compared to the previous values
    const hasNewPermission = currentPermissionTitles.some(
      (title) => !prevPermissionTitlesRef.current.includes(title),
    );
    let clinicAdministrationGroup = [];
    let stacionaryGroup = [];
    if (roles.master) {
      //If a user is admin simply add the master pages to the nav bar
      filteredPages.push(NAV_BAR_PAGES.filter((page) => page.role == MASTER));
    } else if (hasNewPermission) {
      // Execute the loop if a new permission is found
      for (let i = 0; i < NAV_BAR_PAGES.length; i++) {
        const currentPage = NAV_BAR_PAGES[i];

        if (NAV_BAR_PAGES.includes(currentPage)) {
          // If the page has no 'roles' array, or the array is empty, we assume it relies purely on Permission
          // If the page HAS a 'roles' array, the user MUST match one of the roles.
          const hasRoleAccess =
            !currentPage.roles ||
            currentPage.roles.length === 0 ||
            currentPage.roles.includes(userRole);

          if (
            currentPage.name === SPAS_HOME_PAGE &&
            Boolean(currentPermissionTitles.includes(currentPage.permission))
          ) {
            const clinic_id = Number(currentClinic?.id);
            if (clinic_id !== null && roles.adminOrEmployee) {
              const clinicObj = {
                ...currentPage,
                path: currentPage.path,
              };
              stacionaryGroup.push(clinicObj);
            }
          } else if (
            currentPage.name === MY_CLINIC &&
            Boolean(currentPermissionTitles.includes(currentPage.permission))
          ) {
            const clinic_id = Number(currentClinic?.id);
            if (clinic_id !== null && roles.adminOrEmployee) {
              const clinicObj = {
                ...currentPage,
                path: currentPage.path + clinic_id,
              };
              clinicAdministrationGroup.push(clinicObj);
            }
          } else if (currentPage?.permission === "Ignore") {
            availablePages.push(currentPage);
          } else if (
            Boolean(
              currentPermissionTitles.includes(currentPage.permission) &&
              hasRoleAccess,
            )
          ) {
            if (currentPage.title == "Appointments") {
              //This is junk but the only way it works
              if (roles.adminOrEmployee) {
                const appointmentsPage = {
                  ...currentPage,
                  path: RESERVATION_ADMINISTRATION,
                };
                availablePages.push(appointmentsPage);
              } else {
                const appointmentsPage = {
                  ...currentPage,
                  path: APPOINTEMENTS,
                };
                availablePages.push(appointmentsPage);
              }
            } else {
              availablePages.push(currentPage);
            }
          }
        }
      }

      if (clinicAdministrationGroup?.length !== 0) {
        const spliceSpot = availablePages.findIndex(
          (element) => element.path === ABOUT_US,
        );
        availablePages.splice(spliceSpot, 0, clinicAdministrationGroup);
      }

      if (stacionaryGroup?.length !== 0) {
        const spliceSpot = availablePages.findIndex(
          (element) => element.path === TEMPLATE,
        );
        availablePages.splice(spliceSpot, 0, stacionaryGroup);
      }

      // Update the filteredPages state
      setFilteredPages(availablePages);

      // Update the ref with the current permission titles
      prevPermissionTitlesRef.current = currentPermissionTitles;
    }
  }, [permissions, getPermissionTitlesArray]);

  const administrationPage = NAV_BAR_PAGES.filter(
    (page) => page.role === MASTER,
  );

  // The AI assistant is enabled per clinic by a master
  const withoutDisabledAi = (pages) =>
    currentClinic?.aiAssistantEnabled
      ? pages
      : pages.filter((page) => page?.path !== AI_ASSISTANT);

  if (profile.email == STACIONAR_EMAIL) {
    const array = [];
    STACIONAR_MAIL_PAGES.forEach((page) => array.push(page));
    return withoutDisabledAi(array);
  } else return roles.master ? administrationPage : withoutDisabledAi(filteredPages);
}

export { useGetCollapsedSidebarIcons };
